export default __webpack_public_path__ + "static/media/flyback_async_int_mosfet_dc_ssr.0e5b1d1d.svg";